import { Link } from 'react-router-dom';
import { cfInlineImage } from '../../lib/image';
import { SectionHeading } from '../ui';
import { DOCTORS } from './homeData';

/**
 * C11 team strip: eyebrow, light H2, intro; two gradient link tiles and three
 * doctor cards (portrait, name, pink credential line, "Learn more"). Photos
 * reserve their aspect ratio so no empty boxes flash while they load.
 */

const TILES = [
  { to: '/meet-the-doctors/', label: 'Meet the Doctors' },
  { to: '/about-us/', label: 'About Our Office' },
];

export default function TeamStrip() {
  return (
    <section className="ve-section ve-home-team" aria-labelledby="home-team-title">
      <div className="ve-container">
        <SectionHeading
          eyebrow="Your care team"
          title="Meet the Doctors"
          id="home-team-title"
          align="center"
          intro="Three doctors, one gentle, nervous-system focused approach for newborns, kids, expecting moms, and grown-ups."
        />
        <div className="ve-home-team-grid">
          <div className="ve-home-team-tiles">
            {TILES.map((t) => (
              <Link key={t.to} to={t.to} className="ve-home-team-tile">
                {t.label}
              </Link>
            ))}
          </div>
          <ul className="ve-home-doctors">
            {DOCTORS.map((d) => (
              <li key={d.to}>
                <Link to={d.to} className="ve-home-doctor">
                  <span className="ve-photo-frame ve-photo-frame--square">
                    <img src={cfInlineImage(d.img)} alt={`Portrait of ${d.name}`} width="425" height="425" loading="lazy" decoding="async" />
                  </span>
                  <span className="ve-home-doctor-name">{d.name}</span>
                  <span className="ve-home-doctor-note">{d.note}</span>
                  <span className="ve-home-doctor-more">Learn more</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
